import React from 'react';

const ShimmerCard = () => {
  return (
    <div className="px-0 py-0 mt-1 mb-2 h-[50px] bg-white rounded-lg shadow-sm animate-pulse">
      <div className="p-4">
        <div className="flex justify-between items-center w-full">
          {/* Name and Date Section */}
          <div className="flex flex-col items-start w-3/4 space-y-2">
            <div className="h-3 bg-gray-300 rounded w-20"></div>
            <div className="h-2 bg-gray-200 rounded w-16"></div>
          </div>

          {/* Value and Volume Section */}
          <div className="flex flex-col items-end w-3/4 space-y-2">
            <div className="h-3 bg-gray-300 rounded w-16"></div>
            <div className="h-2 bg-gray-200 rounded w-12"></div>
          </div>

          {/* Change and Percentage Section */}
          <div className="flex flex-col items-end w-3/4 space-y-2">
            <div className="h-3 bg-gray-300 rounded w-12"></div>
            <div className="h-2 bg-gray-200 rounded w-10"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShimmerCard;